import { render, staticRenderFns } from "./PolicyApprove.vue?vue&type=template&id=aebfc7dc&scoped=true&"
import script from "./PolicyApprove.vue?vue&type=script&lang=js&"
export * from "./PolicyApprove.vue?vue&type=script&lang=js&"
import style0 from "./PolicyApprove.vue?vue&type=style&index=0&id=aebfc7dc&prod&lang=css&"
import style1 from "./PolicyApprove.vue?vue&type=style&index=1&id=aebfc7dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebfc7dc",
  null
  
)

export default component.exports